import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";

/**
 * Menu dropdown de exportação da Trilha de Ajustes (CSV/PDF, mês ou tudo).
 */
export function TrilhaAjustesMenu({ competencia, onExport }) {
  return (
    <div className="relative group">
      <Button data-testid="fin-trilha-ajustes" variant="outline"
        className="rounded-sm border-primary/50 text-primary hover:bg-primary/10"
        title="Exportar trilha auditável de todos os ajustes/resíduos lançados">
        <FileDown size={14} className="mr-2" /> Trilha de Ajustes
      </Button>
      <div className="absolute right-0 top-full mt-1 w-64 bg-background border rounded-sm shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-20">
        <div className="px-3 py-2 text-xs text-muted-foreground border-b bg-muted/40">
          Competência {competencia}
        </div>
        <button data-testid="fin-trilha-csv-mes" onClick={() => onExport("csv", "competencia")}
          className="w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2">
          <FileDown size={12} /> CSV do mês
        </button>
        <button data-testid="fin-trilha-pdf-mes" onClick={() => onExport("pdf", "competencia")}
          className="w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2">
          <FileDown size={12} /> PDF do mês
        </button>
        <div className="px-3 py-2 text-xs text-muted-foreground border-t border-b bg-muted/40">
          Histórico completo
        </div>
        <button data-testid="fin-trilha-csv-tudo" onClick={() => onExport("csv", "tudo")}
          className="w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2">
          <FileDown size={12} /> CSV completo
        </button>
        <button data-testid="fin-trilha-pdf-tudo" onClick={() => onExport("pdf", "tudo")}
          className="w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2">
          <FileDown size={12} /> PDF completo
        </button>
      </div>
    </div>
  );
}
